import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRun = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M10.6971 10.3501L9.8971 9.95007C9.6971 9.85007 9.3971 9.95006 9.1971 10.1501L8.0971 12.3501C7.7971 12.8501 7.2971 13.1501 6.7971 13.1501C6.5971 13.1501 6.2971 13.0501 6.0971 12.9501C5.3971 12.5501 5.0971 11.6501 5.3971 10.9501L6.4971 8.75006C6.8971 7.95006 7.5971 7.25007 8.4971 6.95007C9.3971 6.65007 10.2971 6.75006 11.1971 7.15006L13.3971 8.25006L16.0971 9.65006C16.2971 9.75006 16.4971 9.75005 16.6971 9.55005L18.1971 8.05005C18.7971 7.45005 19.6971 7.45005 20.2971 8.05005C20.8971 8.65005 20.8971 9.55006 20.2971 10.1501L18.7971 11.6501C17.6971 12.7501 16.0971 12.9501 14.7971 12.3501L13.3971 11.6501L12.2971 13.6501L15.1971 15.55C15.7971 15.95 16.1971 16.45 16.4971 17.05L17.7971 20.6501C18.0971 21.4501 17.7971 22.2501 16.9971 22.6501C16.7971 22.7501 16.5971 22.7501 16.3971 22.7501C15.7971 22.7501 15.2971 22.4501 14.9971 21.8501L13.6971 18.2501C13.6971 18.1501 13.5971 18.05 13.4971 18.05L11.0971 16.4501L10.8971 17.05C10.3971 18.45 9.0971 19.3501 7.5971 19.3501C7.2971 19.3501 6.9971 19.3501 6.6971 19.2501L4.3971 18.6501C3.5971 18.4501 3.0971 17.6501 3.2971 16.8501C3.4971 16.0501 4.2971 15.5501 5.0971 15.7501L7.3971 16.3501C7.5971 16.4501 7.8971 16.25 7.9971 16.05L8.1971 15.4501",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.8541 6.77563C13.1973 6.77563 11.8541 5.43249 11.8541 3.77563C11.8541 2.11878 13.1973 0.775635 14.8541 0.775635C16.511 0.775635 17.8541 2.11878 17.8541 3.77563C17.8541 5.43249 16.511 6.77563 14.8541 6.77563Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	}));
});
export default SvgRun;
